import type { Action } from 'state/actions';

import type { DailyBlotterQuotes } from '../dailyBlotter.model';

export function quotesReducer(state: DailyBlotterQuotes = {}, action: Action): DailyBlotterQuotes {
  switch (action.type) {
    case 'DAILY_BLOTTER_QUOTES_RECEIVED': {
      const newState = action.quotes.reduce<DailyBlotterQuotes>((acc, quote) => {
        return { ...acc, [quote.externalQuoteId]: quote };
      }, {});
      return newState;
    }

    default:
      return state;
  }
}
